import { createTheme } from '@mui/material/styles';
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';
import tableLocalization from './tableLocalization';
import { getTokens } from './tokens';

export const theme = (customization) => {
  const mode = customization?.navType === 'dark' ? 'dark' : 'light';
  const t = getTokens(mode, customization?.palette);

  const themeOption = {
    t,
    mode,
    customization,

    heading: t.text,
    paper: t.panel,
    backgroundDefault: t.bg,
    background: t.canvas,
    darkTextPrimary: t.text2,
    darkTextSecondary: t.text3,
    textDark: t.text,
    menuSelected: t.primaryText,
    menuSelectedBack: t.sel,
    divider: t.border
  };

  const themeOptions = {
    direction: 'ltr',
    palette: themePalette(themeOption),
    mixins: {
      toolbar: {
        minHeight: '48px',
        padding: '16px',
        '@media (min-width: 600px)': {
          minHeight: '48px'
        }
      }
    },
    typography: themeTypography(themeOption),
    tableLocalization: tableLocalization()
  };

  const themes = createTheme(themeOptions);
  themes.components = componentStyleOverrides(themeOption);

  return themes;
};

export default theme;